import jsPDF from 'jspdf';
import { StudentProgress } from '../types';

export const generateCertificate = (progress: StudentProgress): void => {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  // Set up colors
  const primaryColor = '#1f2937'; // gray-800
  const accentColor = '#3b82f6'; // blue-500
  const goldColor = '#f59e0b'; // amber-500

  // Background
  pdf.setFillColor(249, 250, 251); // gray-50
  pdf.rect(0, 0, 297, 210, 'F');

  // Border
  pdf.setDrawColor(accentColor);
  pdf.setLineWidth(3);
  pdf.rect(10, 10, 277, 190);

  // Inner border
  pdf.setDrawColor(goldColor);
  pdf.setLineWidth(1);
  pdf.rect(15, 15, 267, 180);

  // Header
  pdf.setTextColor(primaryColor);
  pdf.setFontSize(32);
  pdf.setFont('helvetica', 'bold');
  pdf.text('CERTIFICATE OF COMPLETION', 148.5, 40, { align: 'center' });

  // Subtitle
  pdf.setFontSize(18);
  pdf.setFont('helvetica', 'normal');
  pdf.text('Robotics Safety Training', 148.5, 55, { align: 'center' });

  // Decorative line
  pdf.setDrawColor(goldColor);
  pdf.setLineWidth(2);
  pdf.line(60, 65, 237, 65);

  // Main text
  pdf.setFontSize(16);
  pdf.setTextColor(primaryColor);
  pdf.text('This certifies that', 148.5, 85, { align: 'center' });

  // Student name (email)
  pdf.setFontSize(24);
  pdf.setFont('helvetica', 'bold');
  pdf.setTextColor(accentColor);
  pdf.text(progress.email, 148.5, 105, { align: 'center' });

  // Achievement text
  pdf.setFontSize(16);
  pdf.setFont('helvetica', 'normal');
  pdf.setTextColor(primaryColor);
  pdf.text('has successfully completed the comprehensive', 148.5, 125, { align: 'center' });
  pdf.text('Robotics Safety Training Program', 148.5, 140, { align: 'center' });

  // Score
  const overallScore = progress.sections.reduce((sum, section) => sum + section.score, 0) / progress.sections.length;
  pdf.setFontSize(14);
  pdf.text(`with a score of ${Math.round(overallScore * 100)}%`, 148.5, 155, { align: 'center' });

  // Date
  const completionDate = progress.completedAt || new Date();
  pdf.setFontSize(12);
  pdf.text(`Completed on: ${completionDate.toLocaleDateString()}`, 148.5, 170, { align: 'center' });

  // Footer
  pdf.setFontSize(10);
  pdf.setTextColor(128, 128, 128);
  pdf.text('Pack of Parts - Robotics Safety Certification', 148.5, 185, { align: 'center' });

  // Signature lines
  pdf.setDrawColor(primaryColor);
  pdf.setLineWidth(0.5);

  // Left signature
  pdf.line(50, 190, 120, 190);
  pdf.setFontSize(10);
  pdf.setTextColor(primaryColor);
  pdf.text('Safety Instructor', 85, 195, { align: 'center' });

  // Right signature
  pdf.line(177, 190, 247, 190);
  pdf.text('Program Director', 212, 195, { align: 'center' });

  // Generate filename
  const filename = `robotics-safety-certificate-${progress.email.replace('@', '-').replace('.', '-')}.pdf`;

  // Download the PDF
  pdf.save(filename);
};

export const canGenerateCertificate = (progress: StudentProgress): boolean => {
  return progress.sections.every(section => section.passed) &&
         progress.completedAt !== undefined;
};